import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import styles from './index.module.css';
import ThemeSwitch from '../ThemeSwitch';
import { Clock, Coin, Logo } from '../../assets';
import GlowButton from '../GlowButton';
import { motion, AnimatePresence } from 'framer-motion';

const MobileMenu = (props) => {

    const [open, setOpen] = useState(false);
    const [isPuzzleDropdownMobileOpen, setIsPuzzleDropdownMobileOpen] = useState(false);

    function formatTime(val) {
        const seconds = val / 1000;
        var minutes = parseInt(seconds / 60);
        const secondVal = parseInt(seconds % 60);
        var hours = parseInt(minutes / 60);
        minutes < 10 && (minutes = '0' + minutes);
        hours < 10 && (hours = '0' + hours);
        return hours + ':' + minutes + ':' + secondVal;
      }

    return (
        <>
        <input checked={open} onChange={() => setOpen(!open)} type="checkbox" id={styles.pivot}/>
  <label for={styles.pivot} className={styles["pivot-trigger"]}>
    <span></span>
    <span></span>
    <span></span>
  </label>
  {open && <div className={styles.overlay}>
    <div className='cursor-pointer' onClick={() => (window.location.href = '/')}>
              <img src={Logo} width={50}/>
          </div>
  <a style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} className={`navlink `} onClick={() => {
            window.location.href = '/';
          }}>Home</a>
          <a style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} className='navlink' onClick={() => {
              window.location.href = 'https://analysis.chessmind.io';
          }}>Analysis</a>
          <a style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} className='navlink' onClick={() => {
              window.location.href = 'https://chessmind.io/openings';
          }}>Openings</a>
          {/* Play dropdown 
          <div className="w-full flex flex-col items-center">
            <div 
              className="flex items-center justify-center w-full"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                props.setIsPlayDropdownOpen(prevState => !prevState);
              }}
            >
              <a 
                style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} 
                className='navlink flex items-center'
              >
                Play
                <svg 
                  className={`ml-1 w-4 h-4 transition-transform duration-300 ${props.isPlayDropdownOpen ? 'rotate-180' : ''}`} 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </a>
            </div>
            
            <AnimatePresence>
              {props.isPlayDropdownOpen && (
                <motion.div
                  initial={{ opacity: 0, height: 0, scale: 0.95 }}
                  animate={{ opacity: 1, height: 'auto', scale: 1 }}
                  exit={{ opacity: 0, height: 0, scale: 0.95 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                  className="w-full flex flex-col items-center overflow-hidden"
                >
                  <a 
                    style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} 
                    className='navlink text-sm py-3 px-4 my-1 w-[80%] rounded-lg bg-white/5 hover:bg-white/15 hover:scale-105 transition-all duration-300 flex items-center justify-center'
                    onClick={() => {
                      window.location.href = 'https://analysis.chessmind.io/?mode=computer';
                      props.setIsPlayDropdownOpen(false);
                      setOpen(false);
                    }}
                  >
                    <span className="flex items-center">
                      <span className="mr-2">🤖</span>
                      Play Computer
                    </span>
                  </a>
                  <a 
                    style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} 
                    className='navlink text-sm py-3 px-4 my-1 w-[80%] rounded-lg bg-white/5 hover:bg-white/15 hover:scale-105 transition-all duration-300 flex items-center justify-center'
                    onClick={() => {
                      window.location.href = 'https://analysis.chessmind.io/?mode=online';
                      props.setIsPlayDropdownOpen(false);
                      setOpen(false);
                    }}
                  >
                    <span className="flex items-center">
                      <span className="mr-2">👥</span>
                      Play Online
                    </span>
                  </a>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          */}
          <div className="w-full flex flex-col items-center">
            <div 
              className="flex items-center justify-center w-full"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsPuzzleDropdownMobileOpen(prevState => !prevState);
              }}
            >
              <a 
                style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} 
                className='navlink flex items-center'
              >
                Puzzles
                <svg 
                  className={`ml-1 w-4 h-4 transition-transform duration-300 ${isPuzzleDropdownMobileOpen ? 'rotate-180' : ''}`} 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </a>
            </div>
            <AnimatePresence>
              {isPuzzleDropdownMobileOpen && (
                <motion.div
                  initial={{ opacity: 0, height: 0, scale: 0.95 }}
                  animate={{ opacity: 1, height: 'auto', scale: 1 }}
                  exit={{ opacity: 0, height: 0, scale: 0.95 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                  className="w-full flex flex-col items-center overflow-hidden"
                >
                  <a 
                    style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} 
                    className='navlink text-sm py-3 px-4 my-1 w-[80%] rounded-lg bg-white/5 hover:bg-white/15 hover:scale-105 transition-all duration-300 flex items-center justify-center'
                    onClick={() => {
                      window.location.href = 'https://analysis.chessmind.io/puzzles';
                      setIsPuzzleDropdownOpen(false);
                      setOpen(false);
                    }}
                  >
                    <span className="flex items-center">
                      <span className="mr-2">🧩</span>
                      All Puzzles
                    </span>
                  </a>
                  <a 
                    style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} 
                    className='navlink text-sm py-3 px-4 my-1 w-[80%] rounded-lg bg-white/5 hover:bg-white/15 hover:scale-105 transition-all duration-300 flex items-center justify-center'
                    onClick={() => {
                      window.location.href = 'https://analysis.chessmind.io/puzzles?mode=race';
                      setOpen(false);
                    }}
                  >
                    <span className="flex items-center">
                      <span className="mr-2">🏁</span>
                      Puzzle Race
                    </span>
                  </a>
                 {/* <a 
                    style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} 
                    className='navlink text-sm py-3 px-4 my-1 w-[80%] rounded-lg bg-white/5 hover:bg-white/15 hover:scale-105 transition-all duration-300 flex items-center justify-center'
                    onClick={() => {
                      window.location.href = 'https://analysis.chessmind.io/puzzles?mode=daily';
                      setOpen(false);
                    }}
                  >
                    <span className="flex items-center">
                      <span className="mr-2">📅</span>
                      Daily Puzzle
                    </span>
                  </a>
                  */}
                  <a 
                    style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} 
                    className='navlink text-sm py-3 px-4 my-1 w-[80%] rounded-lg bg-white/5 hover:bg-white/15 hover:scale-105 transition-all duration-300 flex items-center justify-center'
                    onClick={() => {
                      window.location.href = 'https://analysis.chessmind.io/puzzles?mode=themes';
                      setOpen(false);
                    }}
                  >
                    <span className="flex items-center">
                      <span className="mr-2">🎨</span>
                      Puzzle Themes
                    </span>
                  </a>
                  <a 
                    style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} 
                    className='navlink text-sm py-3 px-4 my-1 w-[80%] rounded-lg bg-white/5 hover:bg-white/15 hover:scale-105 transition-all duration-300 flex items-center justify-center'
                    onClick={() => {
                      window.location.href = 'https://analysis.chessmind.io/leaderboard';
                      setOpen(false);
                    }}
                  >
                    <span className="flex items-center">
                      <span className="mr-2">🏆</span>
                      Leaderboard
                    </span>
                  </a>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          {!props.logged && <>
            <a style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} className='navlink' onClick={() => {
              window.location.href = '/pricing';
          }}>Pricing</a>
          <a style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} className='navlink' onClick={() => {
              window.location.href = '/about';
          }}>About</a>
          </>}
          {props.logged ? <><a style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} className='navlink' onClick={() => {
              window.location.href = '/settings';
          }}>Settings</a>
          <a style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} className='navlink' onClick={() => {
              window.location.href = '/settings?query=coins';
          }}>Coins</a>
          <a style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} className='navlink' onClick={() => {
              window.location.href = '/settings?query=var';
          }}>Variations</a>
          <a style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} className='navlink' onClick={() => {
              window.location.href = '/settings?query=stat';
          }}>Statistics</a>
          <a style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} className='navlink' onClick={() => {
              window.location.href = '/settings?query=tickets';
          }}>Tickets</a>
          <a style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} className='navlink' onClick={() => {
            localStorage.removeItem('chesscloud-token');
            document.cookie = `chesscloud-token=; domain=.chessmind.io; path=/; max-age=-99999999`;
            window.location.href = '/';
          }}>Logout</a>
          {props.selected !== 0 && <ThemeSwitch setDark={props.setDark} dark={props.dark} />}
          </> :           <a style={{color: (props.selected !== 0 && !props.dark) ? 'black' : 'white'}} className='navlink' onClick={() => {
              window.location.href = '/contact';
          }}>Contact</a>}
          {props.logged ? <><div className='flex items-center justify-center gap-3 w-[80px] cursor-pointer mr-[15px]'>
          <img src={Coin} width={30} height={30}/>
          <a className={(props.selected !== 0 && !props.dark) ? 'text-black' : 'text-white'} onClick={() => {
            
          }}>{props.coin}</a>
          </div>
          <div className='flex items-center justify-between w-[120px] mr-[20px] cursoir-pointer'>
          <Clock />
          <a className={(props.selected !== 0 && !props.dark) ? 'text-black' : 'text-white'} onClick={() => {
            
          }}>{formatTime(props.time)}</a>
          </div></> : <>
          <GlowButton onClick={() => {window.location.href = '/login'}} text="Sign In"/>
          <GlowButton onClick={() => {window.location.href = '/register'}} text="Sign Up"/>
          </>}
  </div>}
  
  </>
    )
}

export default MobileMenu;
